import { request } from '@/utils/request/request';

export function getBillRecords(query) {
  return request({
    url: 'api/fee/v1/GetZhangDanJiLu',
    method: 'get',
    params: query,
  });
}
export function getEleRecords(params) {
  return request({
    url: 'api/fee/v1/GetYongDianRecordsBySBID',
    method: 'GET',
    params,
  });
}
